import React, { useEffect, useState } from "react";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import { Box, CircularProgress } from "@mui/material";
import ApiService from "../../Frontend/Api/ApiServices";
import InputField from "../../Components/Common/InputField";
import FormGroup from "../../Components/Common/FormGroup";
import PhoneInput from "../../Components/Common/PhoneInput";
import styled from "styled-components";

const validationSchema = Yup.object().shape({
  name: Yup.string().required("Name is required"),
  address: Yup.string().required("Address is required"),
  contact: Yup.string()
    .required("Contact number is required")
    .matches(/^[0-9]+$/, "Contact number must contain only digits"),
  email: Yup.string()
    .email("Invalid email format")
    .required("Email is required"),
  comments: Yup.string().required("Comments are required"),
});

function ContactUs() {
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState({ success: false, error: false });

  const handleSubmit = async (values, { resetForm }) => {
    setIsSubmitting(true);
    try {
      const response = await ApiService.submitContactForm(values);
      if (response.data) {
        setSubmitStatus({ success: true, error: false });
        resetForm();
      }
    } catch (error) {
      setSubmitStatus({ success: false, error: true });
      console.error("Error submitting form:", error);
    } finally {
      setIsSubmitting(false);
    }
  };

  useEffect(() => {
    if (submitStatus.success) {
      setTimeout(() => {
        setSubmitStatus({ success: false, error: false });
      }, 3000);
    }
  }, [submitStatus]);

  return (
    <div id="home-video-main">
      <section className="contact-shortly">
        <h6 className="shortly-title"><span>We will get in</span> touch shortly</h6>
        <Formik
          initialValues={{
            name: "",
            address: "",
            contact: "",
            contact_code: "",
            email: "",
            comments: "",
          }}
          validationSchema={validationSchema}
          onSubmit={handleSubmit}
        >
          {({ setFieldValue, values, errors, touched, handleChange, handleBlur, getFieldProps }) => (
            <Form className="show-form-grop">
              <FormGroup
                label="Name"
                name="name"
                className="loginField w-100"
                requiredField
              >
                <InputField
                  type="text"
                  name="name"
                  className={`textarea`}
                  {...getFieldProps("name")}
                />

              </FormGroup>
              <FormGroup
                label="Address"
                name="address"
                className="loginField w-100"
                requiredField
              >
                <InputField
                  type="text"
                  name="address"
                  className={`textarea`}
                  {...getFieldProps("address")}
                />
              </FormGroup>
              <FormGroup
                label="Contact no"
                name="contact"
                className="loginField w-100"
                requiredField
              >
                <Country> 
                  <PhoneInput
                    dialCodeName="contact_code"
                    value={values.contact_code}
                    name="contact"
                    onChange={(value, country) => {
                      setFieldValue("contact_code", country.dialCode);
                    }}
                    className="phone-number-input"
                    contactstyle
                  />
                </Country>
              </FormGroup>
              <FormGroup
                label="Email"
                name="email"
                className="loginField w-100"
                requiredField
              >
                <InputField
                  type="email"
                  name="email"
                  className={`textarea`}
                  {...getFieldProps("email")}
                />
              </FormGroup>
              <FormGroup
                label="Questions/Comments"
                name="comments"
                className="loginField w-100"
                requiredField
              >
                <div className="input-icon">
                  <textarea
                    id="comments"
                    className={`form-control emergency-input show-form-textarea ${touched.comments && errors.comments ? "is-invalid" : ""
                      }`}
                    rows="9"
                    name="comments"
                    value={values.comments}
                    onChange={handleChange}
                    onBlur={handleBlur}
                  ></textarea>
                </div>
              </FormGroup>

              <div className="show-form-button">
                <button
                  className="btn-green-contact"
                  type="submit"
                  disabled={isSubmitting}
                >
                  {isSubmitting ? (
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                      <CircularProgress size={20} color="inherit" />
                      Submitting...
                    </Box>
                  ) : (
                    "Submit"
                  )}
                </button>
              </div>

              {submitStatus.success && (
                <div className="alert alert-success mt-3 text-center text-success">
                  Thank you for your message! We will get back to you shortly.
                </div>
              )}
              {submitStatus.error && (
                <div className="alert alert-danger mt-3 invalid-feedback text-center">
                  There was an error submitting your message. Please try again.
                </div>
              )}
            </Form>
          )}
        </Formik>
      </section>
    </div>
  );
}

export default ContactUs;

const Country = styled.div`
  .react-tel-input .form-control {
    width: 100%;
    margin: 5px 0;
    height: 51px !important;
    border-radius: 20px;
    border: 1px solid #ccc;
    box-sizing: border-box;
    background-color: rgba(237, 239, 241, 0.932);
  }

  .react-tel-input .flag-dropdown {
    top: 0;
    bottom: 0;
    padding: 0;
    background-color: transparent !important;
    border: transparent !important;
    border-radius: 3px 0 0 3px;
  }

  input:-internal-autofill-selected {
    background-image: none !important;
    background: rgba(255, 255, 255, 0.2) !important;
    color: fieldtext !important;
  }
  .react-tel-input.phone-number-input{
  margin-bottom: 5px;
  }
`;
